import {
    Whatshot as PeakPeakIcon,
    NightsStay as OffPeakPeakIcon,
    FlashOn as PeakOffPeakIcon,
    Brightness2 as OffOffIcon,
} from '@mui/icons-material';

// Tooltip descriptions for Data Analytics Page
export const dataAnalyticsTooltips = {
    totalConsumption: 'Total cumulative energy consumption over the entire data collection period.',
    totalProduction: 'Total cumulative energy production over the entire data collection period.',
    avgConsumption: 'Average daily energy consumption calculated across all days in the dataset.',
    avgProduction: 'Average daily energy production calculated across all days in the dataset.',
    duration: 'Total number of days covered by the collected energy data.',
    frequency: 'Temporal resolution of the energy measurements (hourly for aggregated data, per-minute for disaggregated data).',
    combined: 'Time series chart displaying both consumption and production data over the selected period for comparative analysis.',
    dailyAverage: 'Daily average energy values plotted over time, showing consumption and production trends on a day-by-day basis.',
    hourlyAverage: 'Average consumption and production values by hour of the day (0-23), aggregated across all days to show typical daily patterns.',
    weeklyFlexibility: 'Weekly flexibility analysis showing baseline energy values with upper and lower flexibility ranges, indicating potential for load adjustment.',
};

// Tooltip descriptions for Forecasts Page
export const forecastsTooltips = {
    nextDayForecast: 'Next day energy consumption forecast showing baseline prediction with flexibility ranges indicating potential load adjustment capabilities.',
    nextDayForecastProduction: 'Next day energy production forecast displaying baseline prediction with flexibility ranges showing potential output variation.',
    nextDaysForecast: 'Multi-day energy consumption forecast with baseline predictions and flexibility ranges for demand response planning.',
    nextDaysForecastProduction: 'Multi-day energy production forecast showing baseline predictions with flexibility ranges indicating potential output adjustments.',
    efiChart: 'Energy Flexibility Index (EFI) chart displaying EFI UP and EFI DOWN values per hour, color-coded by flexibility categories to show load shifting potential.',
    efiPie: 'Distribution of flexibility categories throughout the day, showing the percentage of time spent in each peak/off-peak consumption and production combination.',
};

// Color configuration for flexibility categories
export const categoryColors = {
    peak_peak: '#947fff',        // Purple
    off_peak_peak: '#fb5801',    // Orange (portokali)
    peak_off_peak: '#ba3da0',    // Pinkish (rozaki)
    off_off: '#5581fc',          // Blue (movaki)
};

// Flexibility categories configuration
export const flexibilityCategories = [
    {
        title: 'Peak Consumption & Peak Production Hours',
        description: 'High demand during peak times.',
        icon: <PeakPeakIcon />,
        color: categoryColors.peak_peak,
    },
    {
        title: 'Off-Peak Consumption & Peak Production Hours',
        description: 'Low demand during peak times.',
        icon: <OffPeakPeakIcon />,
        color: categoryColors.off_peak_peak,
    },
    {
        title: 'Peak Consumption & Off-Peak Production Hours',
        description: 'High demand during off-peak times.',
        icon: <PeakOffPeakIcon />,
        color: categoryColors.peak_off_peak,
    },
    {
        title: 'Off-Peak Consumption & Off-Peak Production Hours',
        description: 'Low demand during off-peak times.',
        icon: <OffOffIcon />,
        color: categoryColors.off_off,
    },
]; 